export const VIEW_TYPE = {
  FORM: 'form',
  TREE: 'list',
}
